import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useModuleIds } from 'portal/lib/hooks'
import { companiesLoad } from 'portal/store/companies/actions'

export const useCompaniesLoader = projectId => {
  const dispatch = useDispatch()
  const { accountId } = useModuleIds()

  const reload = useCallback(() => {
    if (!accountId || !projectId) {
      return
    }
    dispatch(companiesLoad(accountId, projectId))
  }, [dispatch, accountId, projectId])

  useEffect(() => {
    reload()
  }, [reload])

  const { loading, error, items } = useSelector((state: any) => {
    return state.companies
  })

  return {
    loading,
    error,
    items,
    reload
  }
}
